<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="noindtt"><a id="page_ii"></a><span class="bold">Published and Forthcoming by New Academia Publishing</span></p>
<p class="noind">GOD, GREED, AND GENOCIDE: The Holocaust through the Centuries, by Arthur Grenke.</p>
<p class="noind">NATIONALISM, HISTORIOGRAPHY AND THE (RE)CONSTRUCTION OF THE PAST, edited by Claire Norton</p>
<p class="noind">AN ARCHITECT OF DEMOCRACY: Buildig a Mosaic of Peace, by James Robert Huntley.</p>
<p class="noind">SHAKESPEARE’S THEATER OF LIKENESS, by R. Allen Shoaf.</p>
<p class="noind">HERETICAL EMPIRICISM, by Pier Paolo Pasolini. Eds., trs., Ben Lawton and Louise K.Barnett.</p>
<p class="noind">ON THE ROAD TO BAGHDAD, OR TRAVELING BICULTURALISM: Theorizing a Bicultural Approach to Contemporary World Fiction, Edited by Gönül Pultar.</p>
<p class="noind">LIVING NOVELS: A JOURNEY THROUGH TWENTIETH-CENTURY FICTION, by Sascha Talmor</p>
<p class="noindt"><span class="bold">Russian History and Culture Series</span></p>
<p class="noind">RUSSIAN FUTURISM: A HISTORY, by Vladimir Markov. With an Introduction by Ronald Vroon.</p>
<p class="noind">WORDS IN REVOLUTION: Russian Futurist Manifestoes 1912-1928. Eds., trs., Anna Lawton and Herbert Eagle.</p>
<p class="noind">THE INNER ADVERSARY: Struggle Against Philistinism as the Moral Mission of the Russian Intelligentsia, by Timo Vihavainen.</p>
<p class="noind">IMAGING RUSSIA 2000: FILM AND FACTS, Anna Lawton (CHOICE Outstanding Academic Title 2005)</p>
<p class="noind">BEFORE THE FALL: SOVIET CINEMA IN THE GORBACHEV YEARS, Anna Lawton</p>
<p class="noind">RED ATTACK, WHITE RESISTANCE: Civil War in South Russia 1918, by Peter Kenez.</p>
<p class="noind">RED ADVANCE, WHITE DEFEAT: Civil War in South Russia 1919-1920, by Peter Kenez.</p>
<p class="noind">ASPECTS OF BALKAN CULTURE, Jelena Milojkovic-Djuric</p>
<p class="noind">SLAVIC THINKERS OR THE CREATION OF POLITIES, Josette Baers</p>
<p class="noindt"><span class="bold">SCARITH Books (fiction)</span></p>
<p class="noind">ON THE WAY TO RED SQUARE, by Julieta Almeida Rodrigues.</p>
<p class="noind">THE DA VINCI BARCODE, by Judith P. Shoaf</p>
<p class="noindt"><span class="bold">VELLUM Books (non fiction)</span></p>
<p class="noind">A RED SOX FAN’S DIARY OF THE 2004 SEASON, by Derek Catsam</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01a_Fm.vue?3e22d580